import TagManager from 'react-gtm-module';

export const useProfileUpdatedTag = () =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'click_profile_updated',
      category: 'UI Interaction',
      action: 'Click',
      label: 'Profile Updated'
    }
  });
